import React from 'react'
import { AppBar, Typography } from '@material-ui/core'

export const AppbarDisplayName = (props) => (
  <Typography
    variant="h6"
    color="inherit"
    className="pt-8 px-10 text-center"
    data-testid="displayName"
    {...props}
  />
)

const ResponsiveAppbar = ({ avatar, displayName, children }) => {
  return (
    <AppBar position="static" elevation={1}>
      <div className="flex flex-col items-center justify-center py-24">
        {avatar}
        {displayName}
        {children}
      </div>
    </AppBar>
  )
}

export default ResponsiveAppbar
